define((require) => {
    "use strict";

    var Marionette          = require("marionette"),
        _                   = require("underscore"),
        Keyboard            = require("services/Keyboard"),
        Preconditions       = require("shared/util/Preconditions");

    var KEYBOARD_EVENT_REGEX = /((?:(?:ctrl|alt|shift)-)*)(\S+)(?: (.*))?/;

    /**
     * Extends the view to support keyboard configuration.
     */
    var viewConstructor = Marionette.View.prototype.constructor;
    Marionette.View.prototype.constructor = function() {
        // Invoke super constructor
        viewConstructor.apply(this, _.toArray(arguments));

        // Setup keyboard events.
        // The event string can be e.g. "escape", "escape #my-input" or "ctrl-shift-x .blarh tr.blah", which is
        // mapped to a callback similar to the events map.
        // Note that the selector is applied globally, not only in the view's scope!
        if (this.keyboard) {
            _.each(this.keyboard, function(callback, event) {
                var matches = KEYBOARD_EVENT_REGEX.exec(event);

                Preconditions.checkArgument(matches, "Unable to parse keyboard event specification", event);

                var modifier = matches[1] || "",
                    keyName  = matches[2],
                    selector = matches[3] || "";

                var keyCode = Keyboard.KeyCode[keyName.toLocaleUpperCase()];

                Preconditions.checkArgument(keyCode, "Unknown key name", keyName);

                // Monkey the values into a string as listenTo() does not accept a list or object as the second of three parameters.
                this.listenTo(Keyboard.Down, keyCode + "/" + modifier + "/" + selector, function() {
                    callback = _.isString(callback) ? this[callback] : callback;
                    callback.apply(this, arguments);
                });
            }, this);
        }

        this.listenTo(this, "item:rendered collection:rendered", function() {
            // Automatically apply Stickit bindings.
            if (this.bindings) {
                this.stickit();
            }
        });

        // Setup any view controllers
        if (_.isFunction(this.controller)) {
            var Controller = this.controller;
            this.controller = new Controller({view: this});
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/zbone/View.js